module.exports = __webpack_public_path__ + "img/absolut-first-block-bg.ed34c62c.jpg";